import { Resource } from '@centers/interfaces/resource';

// Entity
export interface AccessPointInterface {
  id?: number;
  center_id?: number;
  code?: string;
  name?: string;
  description?: string;
  status?: Status;
  consumeProduct?: boolean;
  created_at?: boolean;
  updated_at?: string;
  deleted_at?: string;
}

export interface AccessPointFormModelInterface {
  id: number;
  center_id: number;
  code: string;
  name: string;
  description: string;
  status: Status;
  consumeProduct: boolean;
  resourceAccessConfigurations: ResourceAccessConfigurationInterface[];
}

// Entity enums
export enum Status {
  Active = 'active',
  Inactive = 'inactive',
  Trashed = 'trashed',
}

export enum AccessType {
  Entry = 'entry',
  Exit = 'exit',
}

// Permission
export const AccessPointPermissionName: string = 'access_points';

// Table Filters interfaces
export interface AccessPointDefaultFilterTableInterface {
  search?: string;
  resource_ids?: number[];
  status: Status[];
}

// Table items interface
export interface AccessPointDefaultTableItemInterface {
  id: number;
  center_id: number;
  code: string;
  name: string;
  resources: Resource;
  status: Status;
  consumeProduct: boolean;
  created_at: boolean;
  updated_at: string;
  deleted_at: string;
}

export interface ResourceAccessConfigurationInterface {
  id: number;
  access_point_id: number;
  resource_id: number;
  access_type: AccessType;
}
